import { z } from 'zod/v4';

import { normalizeAccordionWidgetArgs } from './accordion-widget-args.normalization';
import { partialAccordionWidgetDataSchema } from './partial-accordion-widget-data.schema';

/**
 * Unlike `navigation`/`logo`, `accordion` can be created in any ordinary column — it has no
 * shared-block restriction and no uniqueness rule.
 */
const createAccordionWidgetObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to create the accordion (FAQ) widget in.'),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: partialAccordionWidgetDataSchema
        .optional()
        .describe('Accordion settings. Omit entirely to create one with the default 3-entry list.'),
});

export const createAccordionWidgetArgsSchema = z.preprocess(
    normalizeAccordionWidgetArgs,
    createAccordionWidgetObjectSchema
);
